export const BUILD_SITE = 'JENKINS/BUILD_SITE';
export const BUILD_SITE_COMPLETED = 'JENKINS/BUILD_SITE_COMPLETED';
